module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI Mate 70 Pro+.8a5d6610.png";